import React, { useRef, useEffect, useState } from 'react'
import { Col, Row, Container } from 'react-bootstrap'
import { get } from 'lodash'
import { useHistory } from 'react-router-dom'

import Typography from 'components/atoms/Typography'
import ResponseBlock from 'components/molecules/ResponseBlock'
import CardNews from 'components/molecules/CardNews'
import Pagination from 'components/molecules/Pagination'
import SearchFilters from 'components/organisms/SearchFilters'
import { userCheckMobileScreen } from 'helpers/tools'
import { millisToHuman } from 'helpers/dates'

function PhotoGalleryWidget({ data }) {
  const history = useHistory()
  const photoGalleryRef = useRef()
  const query = new URLSearchParams(history.location.search)
  const title = get(data, 'title')
  const categories = get(data, 'category')
  const queryCategory = query.getAll('category[]')
  const category = queryCategory.length > 0 ? queryCategory : []

  const [currentPage, setCurrentPage] = useState(parseInt(query.get('page')) - 1 || 0)
  const [sortOrder, setSortOrder] = useState(query.get('sort_order') || 'DESC')
  const sortOptions = [
    { name: 'Mais recentes', value: 'created', sortOrder: 'DESC' },
    { name: 'Mais antigos', value: 'created', sortOrder: 'ASC' },
  ]

  const photoGalleryItems = get(data, 'photo_gallery.items')
  const pager = get(data, 'photo_gallery.pager')

  useEffect(() => {
    if (query.toString()) photoGalleryRef.current.scrollIntoView()
  }, [])

  function handleChangeOrder(option) {
    setSortOrder(get(option, 'sortOrder'))
  }

  return (
    <Container ref={photoGalleryRef} className="photo-gallery section-spacing">
      <Col>
        {title && (
          <Typography color="primary" cssClass="title-semibold-md mb-3" variant="p">
            {title}
          </Typography>
        )}
        {categories && (
          <SearchFilters
            filters={[
              {
                text: 'Categorias',
                selectAllText: 'Todas as categorias',
                field: 'category',
                items: categories.map(({ entity: { tid, name } }) => ({
                  value: tid,
                  name,
                  selected: category.includes(tid.toString()),
                })),
              },
            ]}
            selectAllText="Todas as categorias"
            sort={{
              options: sortOptions,
              selected: sortOptions.find((option) => option.sortOrder === sortOrder),
              handleChange: handleChangeOrder,
            }}
            onSubmit={() => setCurrentPage(0)}
          />
        )}
        <Row className="pt-4">
          {photoGalleryItems?.map(({ created, title, main, url, description }) => {
            const image = userCheckMobileScreen()
              ? get(main, 'entity.images.wide.url')
              : get(main, 'entity.images.large.url')

            return (
              <Col className="mb-5" xs={6} md={4} key={created}>
                <CardNews
                  alt={get(main, 'entity.images.alt')}
                  date={millisToHuman(created, { month: 'long', day: 'numeric', year: 'numeric' })}
                  url={get(url, 'path')}
                  image={image}
                  title={title}
                  preview={description}
                  icon={get(main, 'entity.images.large.url') && '/sites/default/files/public/svg_icons/camera.svg'}
                />
              </Col>
            )
          })}
          {(!photoGalleryItems || photoGalleryItems?.length === 0) && (
            <div className="d-flex justify-content-center mt-4">
              <Typography>Nenhum resultado encontrado</Typography>
            </div>
          )}
        </Row>
        <Pagination
          initialPage={currentPage}
          className={`d-none d-md-block`}
          paginationOffset={2}
          totalPages={parseInt(pager?.total_pages)}
          onChangePage={(page) => setCurrentPage(page - 1)}
          useQueryParams
        />
      </Col>
    </Container>
  )
}

export default PhotoGalleryWidget
